import type { FormGroupProps } from '.';

//import BsFormGroup from 'react-bootstrap/FormGroup';

const FormGroup = ({ children, ...props }: FormGroupProps) => {
  return <div {...props}>{children}</div>;
};

export default FormGroup;
